import { createFileRoute } from "@tanstack/react-router";

import { GlossaryIndex } from "../components/glossary/GlossaryIndex";
import { glossaryIndexHead } from "../lib/glossary/head";
import { loadGlossary } from "../lib/glossary/index";
import { GLOSSARY_UI } from "../lib/glossary/ui";
import { documentHeaders } from "../lib/seo";

/** The glossary hub in English, at `/glossary`. */
export const Route = createFileRoute("/glossary/")({
  loader: () => loadGlossary("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? glossaryIndexHead("en", GLOSSARY_UI.en, loaderData) : {},
  component: EnglishGlossaryIndex,
});

function EnglishGlossaryIndex() {
  const bundle = Route.useLoaderData();
  return <GlossaryIndex lang="en" ui={GLOSSARY_UI.en} bundle={bundle} />;
}
